if (!customElements.get('sparklayer-pricing')) {
  class SparklayerPricing extends HTMLElement {
    constructor() {
      super();
      this.id = parseInt(this.getAttribute('product-id'));
      this.string = this.getAttribute('data-string'); 
      this.format = this.getAttribute('data-format'); 
      this.vatRate = parseFloat(this.getAttribute('vat-rate')) || 0; 
    }

    connectedCallback() {
      if (window.spark) {
        this.getData();
      } else {
        return;
      }
    }

    getData() {
      window.spark.getProduct(this.id).then((response) => {

        if (!response?.variants?.length || !response.variants[0].price?.net) {
          return;
        }

        const targetVariant = response.variants[0];
        const priceData = targetVariant.price;
        const rawPrice = priceData.net;


        const priceInCents = rawPrice * 100;
        const taxMultiplier = this.vatRate > 0 ? (1 + this.vatRate / 100) : 1;
        const finalPriceInCents = priceInCents * taxMultiplier;
        const formattedPrice = this.formatMoney(finalPriceInCents, this.format);

        if (this.string && this.string.includes('[[price]]')) {
          this.innerText = this.string.replace('[[price]]', formattedPrice);
        } else {
          this.innerText = formattedPrice;
        }
      }).catch((error) => {
        return;
      });
    }

    formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '{{amount}}'; 

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) return '0';

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      const match = formatString.match(placeholderRegex);
      if (!match) {
        return formatWithDelimiters(cents, 2);
      }

      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  customElements.define('sparklayer-pricing', SparklayerPricing);
}